export const RenderMultiLine = ({
  fallback = null,
  value,
}: {
  value: string;
  fallback?: string | null;
}) => {
  if (!value) return fallback;
  if (value.indexOf("\n") === -1) return value;
  const result: Array<React.ReactNode> = value.split("\n").map((item, key) => (
    <span key={key}>
      {item}
      <br />
    </span>
  ));

  return result;
};
